import { SET_CLAIM_HISTORY_DATA, SET_CLAIM_PROGRESS_DATA } from "../constants/constants";

const initialState = {
    isLoading: true,
    isEmpty: false,
    claimsFAQs: [
        {
            processQuestionNumber: null,
            questionAnswer: "",
            questionText: "",
        }
    ],
    selectedClaimProgressStep: { stepId: "00000000-0000-0000-0000-000000000000" },
    claimProgress: null,
}

const claimsHistoryReducer = function modal(state = initialState, action) {
    switch (action.type) {
        case SET_CLAIM_HISTORY_DATA:
            return {
                ...state,
                isLoading: ('isLoading' in action.payload) ? action.payload.isLoading : state.isLoading,
                isEmpty: ('isEmpty' in action.payload) ? action.payload.isEmpty : state.isEmpty,
            }
        case SET_CLAIM_PROGRESS_DATA:
            return {
                ...state,
                claimProgress: ('claimProgress' in action.payload) ? action.payload.claimProgress : state.claimProgress,
                claimsFAQs: ('claimsFAQs' in action.payload) ? action.payload.claimsFAQs : state.claimsFAQs,
                selectedClaimProgressStep: ('selectedClaimProgressStep' in action.payload) ? action.payload.selectedClaimProgressStep : state.selectedClaimProgressStep,
            }
        default:
            return state
    }
}
export default claimsHistoryReducer;